module.exports = __webpack_public_path__ + "img/decline.a37e4823.svg";